export enum FormStatus {
  Valid = 'VALID',
  Invalid = 'INVALID',
}
